import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

Vue.config.productionTip = false

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Widget: any = wrap(Vue, () => import(`./App.vue`))

window.customElements.define('ida-chatbot', Widget)
